
import { defineComponent, nextTick, PropType, ref } from "vue"
export default defineComponent({
    name: "EmbedCode",
    props: {
        html: {
            type: String,
            required: true
        }
    },
    setup(props, { emit }) {
        const containerRef = ref<HTMLElement>()
        const scriptLoaded = (context: any) => {
            emit("scriptLoaded", context)
        }

        return {
            containerRef,
            scriptLoaded
        }
    },
    async mounted() {
        await nextTick();
        const scripts = this.containerRef?.querySelectorAll('script');

        scripts?.forEach((oldScript: any) => {
            const newScript = document.createElement('script');
            if (oldScript.src) {
                newScript.src = oldScript.src;
                newScript.onload = this.scriptLoaded
            } else {
                newScript.textContent = oldScript.textContent;
            }
            document.body.appendChild(newScript);
            document.body.removeChild(newScript); // to avoid DOM clutter
        });
    }
})
